import { enforce, create, test, only } from "vest";

export default create((currentField, data = {}) => {
    only(currentField);
    test(
        "descuento_comercial",
        "El valor debe ser mayor o igual a 0 y menor o igual a 99",
        () => {
            const v = data.descuento_comercial;
            if (v == null || v === "") {
                return;
            }
            enforce(+v).isBetween(0, 100);
        }
    );
    test(
        "descuento_estrategico",
        "El valor debe ser mayor o igual a 0 y menor o igual a 100",
        () => {
            const v = data.descuento_estrategico;
            if (v == null || v === "") {
                return;
            }
            enforce(+v).isBetween(0, 100);
        }
    );
    test("producto", "Valor requerido", () => {
        enforce(data.producto).isNotEmpty();
    });
    test("cantidad", "Valor requerido", () => {
        enforce(data.cantidad).isNotEmpty();
    });
    test(
        "cantidad",
        "El valor debe ser mayor o igual a 1 y menor o igual a 100",
        () => {
            enforce(data.cantidad).isBetween(1, 100);
        }
    );
});
